import { render } from "./UserPortal.vue?vue&type=template&id=9d89f538&scoped=true"
import script from "./UserPortal.vue?vue&type=script&lang=js"
export * from "./UserPortal.vue?vue&type=script&lang=js"

import "./UserPortal.vue?vue&type=style&index=0&id=9d89f538&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d89f538"]])

export default __exports__